import { TenantEntity } from '../TenantEntity'
export class FbaPallet extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaPallet'
  }
  get palletNo() {
    return this._data.palletNo
  }
  set palletNo(palletNo) {
    this._data.palletNo = palletNo
  }
  get boxesNumber() {
    return this._data.boxesNumber
  }
  set boxesNumber(boxesNumber) {
    this._data.boxesNumber = boxesNumber || 0
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    this._data.cargoName = cargoName
  }
  get status() {
    return this._data.status
  }
  set status(status) {
    this._data.status = status || 0
  }
  get virtualTray() {
    return this._data.virtualTray
  }
  set virtualTray(virtualTray) {
    this._data.virtualTray = virtualTray || false
  }
  get warehouseInUuid() {
    return this._data.warehouseInUuid
  }
  set warehouseInUuid(warehouseInUuid) {
    this._data.warehouseInUuid = warehouseInUuid
  }
}
